<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">区域名称：</span>
        </div>
        <el-input v-model="formData.parkingLotAreaName" size="small" style="width: 280px" />
      </div>

      <!-- <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" type="textarea"/>
      </div> -->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from "js-md5";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "parking-lot-add-one",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "车位区域"
        }
      ],
      mainTitle: "添加车位区域",
      subheading: "",

      formData: {
        parkingLotAreaName: ""
      }
    };
  },
  methods: {
    // 确认添加
    confirm() {
      if (!this.formData.parkingLotAreaName) {
        nError("请输入区域名称");
        return false;
      }
      this.$axios
        .post(api.saveParkingLotArea, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "parking-lot-area"
            });
          }
        })
        .catch(errorHandler());
    },
    cancel() {
      this.$router.push({
        name: "parking-lot-area"
      });
    }
  },
  watch: {}
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingLotArea/ParkingLotAreaAdd.vue